import { useRef } from 'react';
import { CalendarOutlined, DesktopOutlined, MobileOutlined } from 'yoc-ui-library/icons';

import { E_DEVICE_TYPE } from '@common/configs';
import { classesBuilder } from '@common/helpers';
import Card from '@components/Card';
import DeviceFrame from '@components/DeviceFrame';
import Icon from '@components/Icon';
import type { ISectionComponentProps } from '@components/ReportContent/types';

import '../section.scss';
import style from './styles.module.scss';

const OverviewSection = ({ sectionData }: ISectionComponentProps) => {
  const mobileRef = useRef<HTMLDivElement>(null);
  const desktopRef = useRef<HTMLDivElement>(null);

  if (!('images' in sectionData) || !('KPI' in sectionData.data) || !('overview_device_mobile' in sectionData.images)) {
    return <div>Error: Invalid data for Overview section.</div>;
  }

  const { KPI: kpi, PRODUCT: product, TARGETING: targeting, GEO: geo } = sectionData.data;

  return (
    <div className={classesBuilder('section-wrapper', style.overview)}>
      <div className="section-header">
        <h3 className="section-subtitle">Campaign Review</h3>
        <h1 className="section-title">OVERVIEW</h1>
      </div>

      <div className={style['main-grid']}>
        <div className={style.stats}>
          <div className={style['kpi-wrapper']}>
            <Card label="KEY PERFORMANCE INDICATOR">
              <div className={style['card-header']}>
                <Icon name="statistics" />
                <div className={style['card-title']}> KEY PERFORMANCE INDICATOR </div>
              </div>
              <div className={style['kpi-detail']}>
                <h2 className={style['card-subtitle']}>{kpi}</h2>
                <div className={style['icon-box']}>
                  <Icon name="graph" />
                </div>
              </div>
            </Card>
          </div>
          <div className={style['product-wrapper']}>
            <Card>
              <div className={style['product-grid']}>
                <div className={style['icon-column']}>
                  <div className={style['icon-box']}>
                    <Icon name="product" />
                  </div>
                </div>
                <div className={style['text-column']}>
                  <div className={style['card-title']}>PRODUCT</div>
                  <h2 className={style['card-subtitle']}>{product}</h2>
                </div>
              </div>
              <div className={style.divider} />
              <div className={style['product-footer']}>
                <div className={style['product-detail']}>
                  <MobileOutlined />
                  <DesktopOutlined />
                  {/* TODO:There is no such info in the API it's embedded in "product name" eg: YOC Skin Multiscreen */}
                  <span>Multiscreen Campaign</span>
                </div>
              </div>
            </Card>
          </div>

          <div className={style['dual-card-wrapper']}>
            <Card
              label="TARGETING"
              icon={<Icon name="target" />}
              value={targeting}
            />
            <Card
              label="GEOGRAPHY"
              icon={<Icon name="globe" />}
              value={geo}
            />
          </div>

          <div className={style['campaign-runtime-wrapper']}>
            <Card>
              <div className={style['card-header']}>
                <CalendarOutlined />
                <div className={style['card-title']}>CAMPAIGN RUNTIME</div>
              </div>
              <div className={style['campaign-detail']}>
                <div className={style.dates}>
                  {/* TODO: Update these, where do these dates come from?
                Also do we have a duration saved somewhere? There is RUNTIME in ISectionOverviewData what is it?
                it returns a string like "30.10.2024 - 19.11.2024" */}
                  <span>30.10.2024</span>
                  <div className={style.bar} />
                  <span>19.11.2024</span>
                </div>
                <div className={style.days}>21 days</div>
              </div>
            </Card>
          </div>
        </div>

        <div className={style['preview-wrapper']}>
          <div
            className={style['device-container']}
            ref={mobileRef}
          >
            <DeviceFrame
              deviceType={E_DEVICE_TYPE.MOBILE}
              containerRef={mobileRef}
              imageSrc={sectionData.images.overview_device_mobile}
            />
          </div>
          <div
            className={style['device-container']}
            ref={desktopRef}
          >
            <DeviceFrame
              deviceType={E_DEVICE_TYPE.DESKTOP}
              containerRef={desktopRef}
              imageSrc={sectionData.images.overview_device_desktop}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewSection;
